import React from "react";
import { LoginLayout } from "Components";
import LocalLogin from "../LocalLogin/LocalLogin";

const SupportLogin = (): React.JSX.Element => {
  return (
    <LoginLayout>
      <LocalLogin
        title="Support login"
        buttonLabel="Log in"
        allowPasswordReset={false}
      />
    </LoginLayout>
  );
};

export default SupportLogin;
